import React from 'react';
import { useProtectedFileUrl } from '../../utils/protectedFiles';

const ProtectedImage = ({ src, alt, fallback = null, onClick, ...props }) => {
  const { objectUrl, error } = useProtectedFileUrl(src);

  if (!src || error || !objectUrl) {
    return fallback;
  }

  return (
    <img
      src={objectUrl}
      alt={alt}
      onClick={onClick ? (event) => onClick(event, objectUrl) : undefined}
      {...props}
    />
  );
};

export default ProtectedImage;
